import React, { useState, useEffect } from "react";
import { StyleSheet, View } from "react-native";

import Animation from "../animation/LotieView";
import AppConfig from "../../../config/AppConfig";

import ActionButton from "../common/ActionsMenuButton/ActionButton";
import QuestionIcon from "../common/ActionsMenuButton/icons/QuestionIcon";
import SnoozeIcon from "../common/ActionsMenuButton/icons/SnoozeIcon";
import { buttonStyle } from "../common/ActionsMenuButton/utils";
import { getContactMailUrl, openURL } from "../../../helpers/utils";
import AppTheme from "../AppTheme";
import OperationIcon from "../common/ActionsMenuButton/icons/OperationIcon";
import InviteIcon from "../common/ActionsMenuButton/icons/InviteIcon";
import StartTimerIcon from "../common/ActionsMenuButton/icons/StartTimerIcon";

export default function HomeFabButton(props) {
  const {
    showManaMindful = false,
    mariOptions = {},
    style = {},
    viewSnoozedCards = () => {},
    refresh = () => {},
    startTimer = () => {},
    goToChatRoom = () => {},
  } = props;

  const [actionButton, setActionButton] = useState(null);
  const [animation, setAnimation] = useState(null);

  useEffect(() => {
    if (animation) animation.play();
  }, [animation]);

  const actions = [
    <ActionButton.Item
      key={1}
      source={"HomeFabButton"}
      buttonColor="#FFF"
      title="Help"
      onPress={() => {
        openURL(getContactMailUrl());
      }}
    >
      <InviteIcon style={styles.actionButtonIcon} />
    </ActionButton.Item>,
    <ActionButton.Item
        key={1}
        underline
        source={"HomeFabButton"}
        buttonColor="#FFF"
        title="Chat with Mari"
        onPress={() => {
          goToChatRoom();
        }}
    >
      <InviteIcon style={styles.actionButtonIcon} />
    </ActionButton.Item>,
    <ActionButton.Item
      key={6}
      source={"HomeFabButton"}
      buttonColor="#FFF"
      title="Add Timer"
      onPress={startTimer}
    >
      <StartTimerIcon />
    </ActionButton.Item>,
    
    <ActionButton.Item
      key={3}
      underline
      source={"HomeFabButton"}
      buttonColor="#FFF"
      title="View Snoozed Cards"
      onPress={viewSnoozedCards}
    >
      <SnoozeIcon />
    </ActionButton.Item>,

    <ActionButton.Item
      hideShadow
      key={2}
      buttonColor="#FFF"
      title="Refresh"
      onPress={refresh}
    >
      <OperationIcon />
    </ActionButton.Item>,
  ];

  return (
    <View
      style={[
        buttonStyle,
        style,
        mariOptions.mariMessage ? { zIndex: 1000 } : {},
      ]}
      onLayout={(event) => {
        if (actionButton != null)
          actionButton.setParentLayout(event.nativeEvent.layout);
      }}
    >
      {showManaMindful ? (
        <Animation
          ref={(ref) => {
            setAnimation(ref);
          }}
          style={{
            width: 107,
            height: 110,
          }}
          source={require("../../../assets/animations/mana-mindful.json")}
          loop={true}
          autoplay={true}
        />
      ) : (
        <ActionButton
          mariOptions={mariOptions}
          ref={(r) => setActionButton(r)}
          buttonColor={AppTheme.DEFAULT_COLOR}
          zIndex={999}
          source={"HomeFabButton"}
          buttonTextStyle={styles.mainButton}
        >
          {actions}
        </ActionButton>
      )}
    </View>
  );
}

const styles = StyleSheet.create({
  actionButtonIcon: {
    height: 23,
    width: 23,
  },
});
